import { lastElement, getPositionFromAction } from "../../../helpers";

export default function getPositionFromSpot(spot) {
	const pos = getPositionFromAction(lastElement(spot.split(",")));
	return pos;
}
